import * as common from '@/store/common/mutation-types';
export const SEARCH_PARAM = 'SEARCH_PARAM';
export const SEARCH_INIT = `SEARCH_INIT`;
export const STATE_INIT = 'STATE_INIT';
export const STATE_CLEAR = 'STATE_CLEAR';
export const DEFAULT_ASSIGN = 'DEFAULT_ASSIGN';
export const GROUPS = `GROUPS`;
export const COMP_MST_MASTER_INFO = `COMP_MST_MASTER_INFO`;

export default {
	...common,
	SEARCH_PARAM,
	SEARCH_INIT,
	STATE_INIT,
	STATE_CLEAR,
	DEFAULT_ASSIGN,
	GROUPS,
	COMP_MST_MASTER_INFO
};
